import React from 'react';
import CellBackground from './CellBackground';
import './table.css';
import { connect } from 'react-redux';
import { manageBgValue } from './state/cellValue'
import AlertOnClick from './AlertOnClick';
import ClearButton from './ClearButton';
import CommandLines from './CommandLines';
import { showAlert } from "./state/setAlert";

class Table extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            num: 0,
        };

        this.increaseNum = () => {
            let num = this.state.num + 1;
            this.setState({ num: num })
        };

        this.handleShowAlert = () => {
            if (this.props.bgValue === '') {
                this.props.showAlert();
            }
        }
    }

    setRightTabs() {
        let tabs = document.getElementsByClassName('nav nav-tabs')[0];
        tabs.style.right = '-' + (tabs.offsetWidth + 0) + 'px';
    }

    setTablePosition() {
        let topPosition = document.getElementById('rightMenuButtonsContainer').style.top;
        let colorsTable = document.getElementsByClassName('colors-table')[0];
        let tabsList = document.getElementById('tabs').children[0];
        if (this.props.activeTable === 'CIRCLES') {
            colorsTable.style.marginTop = topPosition;
            tabsList.style.top = 0;
        }
        else {
            tabsList.style.top = topPosition
        }

    }

    createTable(x) {
        let rows = [];
        let tableLength = x.data.length;
        if (tableLength === 9) {
            for (let r = 0; r < tableLength; r++) {
                let cells = [];
                for (let c = 0; c < tableLength; c++) {
                    let letter = String.fromCharCode(65 + c);
                    cells.push(
                        <CellBackground
                            key={r + '' + letter}
                            tabY={r}
                            tabX={letter}
                            increaseNum={this.increaseNum}
                            krazekId={x.data[r][c]}
                            posY={c} posX={r}
                            table="colorsTable" />
                    )
                }
                rows.push(<tr key={r}>{cells}</tr>);
            }
        }
        else {
            for (let r = 0; r <= tableLength; r++) {
                let cells = [];
                for (let c = 0; c <= tableLength; c++) {
                    let letter = String.fromCharCode(64 + c);
                    if (r === 0) {
                        cells.push(<th className="single-grid-th" key={letter}><span>{letter}</span></th>)
                    }
                    else if (c === 0) {
                        cells.push(<td className="single-grid-td-first" key={r} tab-y={r} tab-x={letter}>
                            <div className="cell-content">
                                <span>{r}</span>
                            </div>
                        </td>)
                    }
                    else {
                        const isOnCenter = (n) => n % 5 === 0 && n % 10 !== 0;

                        cells.push(
                            <CellBackground
                                key={r + '' + letter}
                                tabY={r}
                                tabX={letter}
                                increaseNum={this.increaseNum}
                                cellStyle={{
                                    borderRight: isOnCenter(c) ? 'red 6px solid' : '',
                                    borderBottom: isOnCenter(r) ? 'red 6px solid' : ''
                                }}
                                krazekId={x.data[r - 1][c - 1]}
                                posX={r - 1} posY={c - 1} />
                        )
                    }
                }
                rows.push(<tr key={r}>{cells}</tr>)
            }
        }

        return <tbody onClick={this.handleShowAlert}
            style={{ border: tableLength === 9 ? '1px solid black' : 'none' }}>{rows}</tbody>
    }

    componentDidMount() {
        this.setTablePosition();
        this.setRightTabs();
        window.addEventListener('resize', this.setRightTabs)
    }

    componentDidUpdate() {
        this.setTablePosition();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.setRightTabs)
    }

    render() {
        return (
            <div className={(this.props.mata.type === 'circles' ? "colors-table " : "") + "table-container"}>
                <AlertOnClick />
                <div className="tableContainer">
                    <table className="gridContainer">
                        {this.createTable(this.props.mata)}
                    </table>
                    <ClearButton />
                </div>
                {this.props.mata.type === 'circles' ? "" :
                    <CommandLines
                        commands={this.props.mata.commands ? this.props.mata.commands : ''}
                        handleShowAlert={this.handleShowAlert}
                        increaseNum={this.increaseNum}
                    />
                }
            </div>
        )
    }
}

export default connect(
    state => ({
        activeTable: state.activeTable,
        bgValue: state.manageBgValue.value,
        krazki: state.krazki,
        commands: state.commands
    }),
    { manageBgValue, showAlert }
)(Table)



// WEBPACK FOOTER //
// ./src/Table.js